import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import PromotionView from "@/features/ventes/components/tarifs/PromotionView";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/promotions/$id/view")({
  loader: requirePermission(TARIF_PERMISSIONS.PROMOTIONS_VIEW),
  staticData: {
    title: "Détails promotion",
    showInBreadcrumb: true,
  },
  component: PromotionView,
});
